import React, { Component } from 'react';
import './Tips.module.scss';
import { history } from 'components/App/components/UnauthenticatedApp';

/**
 * Import components
 */
import DefaultButton from 'components/UI/Button/Button';

import Menu from 'components/UI/Menu/Menu';
import Popup from 'components/UI/Popup/Popup';

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const tipsArray = [
    {   
        image: '8.png',
        text: 'Iets afvinken en daarmee een taak afronden, geeft voldoening. Je maakt dan endorfine aan, dat is een geluksstofje.'
    },
    {   
        image: '9.png',
        text: 'Als je de timer gebruikt, wordt de verleiding om te vroeg te stoppen of te lang door te gaan, een stuk minder groot.'
    },
    {   
        image: '10.png',
        text: 'Plan je huiswerk dezelfde dag als dat je het opkrijgt, dat voorkomt stress. Door te plannen ben je de baas over je eigen tijd.'
    },
    {   
        image: '11.png',
        text: 'Wen jezelf aan dat je je maakwerk op dezelfde dag maakt als dat je het op krijgt. Als je het niet afkrijgt kun je het doorschuiven naar een andere dag.'
    },
    {   
        image: '12.png',
        text: 'Als je een groot doel opdeelt in kleinere doelen, wordt het makkelijker haalbaar.'
    },
    {   
        image: '13.png',
        text: 'Wat is lekkerder? In 1x twee liter cola opdrinken, of iedere dag een glas? Zo werkt het met leren ook. Beter in stukken opgedeeld, dan alles ineens.'
    },
    {   
        image: '14.png',
        text: 'Weet je hoe jouw brein werkt? Door leerstof met aandacht te herhalen, verplaats je de stof van het korte naar het lange termijn geheugen (jouw harde schijf). Hierdoor sla je het beter op en kun je het op lange termijn weer terug halen. Als je de SO’s op deze manier leert, ben je met het proefwerk sneller klaar! Zo bespaar je uiteindelijk tijd en energie.'
    },
    {   
        image: '16.png',
        text: 'Door prioriteiten te stellen in je takenlijst, richt je je aandacht op het juiste.'
    },
    {   
        image: '17.png',
        text: 'Door te werken met een duidelijke en haalbare takenlijst, zul je zien dat het makkelijker is om aan de slag te gaan.'
    },
    {   
        image: '18.png',
        text: 'Probeer om de 25 minuten even 5 minuten pauze te nemen. Na een uur kun je een langere pauze nemen.'
    },
    {   
        image: '19.png',
        text: 'Word je afgeleid door een appje, door een game? Maak er een beloning van! Geniet er van in je pauze.'
    },
    {   
        image: '20.png',
        text: 'Heb je wekelijks terugkerende activiteiten zoals je voetbaltraining of drumles, zet deze dan bij je lesrooster op het 9e uur. Je kunt hier dan rekening mee houden als je gaat plannen.'
    },
    {   
        image: '4.png',
        text: 'Heb je een losse activiteit deze week? Een bioscoopbezoek, de verjaardag van oma of een voetbaltoernooi? Plan dit in het onderste gedeelte in de takenlijst als losse taak zodat je het niet vergeet en er je huiswerktaken omheen kunt plannen! Gebruik hiervoor de +button rechtsboven in het scherm.'
    }
];

export const sixSteps = [
    {   
        title: 'NOTEER JE HUISWERK DIRECT ALS JE HET OP KRIJGT',
        bodyText: '• Klik in het ‘Huiswerk & Agenda’ gedeelte op de plek waar je het huiswerk af moet hebben.\n• Kies of het Maak- (M) of Leerwerk (L) is. Of Maken + Leren (ML) of Lezen (LZ).\n• Noteer het huiswerk in het beschrijvingsveld en gebruik zoveel mogelijk afkortingen.\n• Zo ben je snel klaar en neem je niet teveel ruimte in beslag.\n• Vink de Markering aan als je er een cijfer voor krijgt.\n• Dan valt het goed op en zie je dat het belangrijk is.\n• Als het veel is, maak dan een foto.\n• Je kunt ook een foto maken van aantekeningen die bij dat huiswerk horen.\n• Opslaan.\n• Het zojuist ingevoerde huiswerk wordt blauw.'
    },
    {   
        title: 'CONTROLEER JE HUISWERKOPGAVEN',
        subTitle: 'B.v. Magister, SOM of ELO',
        bodyText: '• Voor je je huiswerk gaat plannen, controleer je of je alles hebt door te vergelijken met bv. Magister of SOM.\n• Check je schoolmail\n• Denk je dingen te missen, vraag het in de klassen-app of bij je klasgenoten.'
    },
    {   
        title: 'DEEL JE HUISWERK OP IN TAKEN',
        subTitle: 'Zet ze op de juiste dag',
        bodyText: '• Plan je huiswerk zo snel mogelijk nadat je het hebt opgekregen. Plan in elk geval voordat je aan je huiswerk begint.\n• Beslis of je je huiswerk gaat opdelen in verschillende blokken en zo ja, hoeveel taken je denkt nodig te hebben. Hoeveel dagen heb je de tijd, zijn er dagen waar je geen of weinig tijd hebt?\n• Klik op het opgegeven nog blauw gekleurde huiswerk.\n• Kies de hoeveelheid taken die je wilt inplannen.\n• Beschrijf de taken\n• Reserveer bij leerwerk de laatste taak om te herhalen\n• Kies de tijden die je denkt nodig te hebben voor de taak.\n• Opslaan.\n• Rechtsonder in de hoek is nu een stapel terecht gekomen met alle taken.\n• Schuif de taken uit je takenstapel naar de juiste dagen.\n• Plan terug in de tijd.\n• Als alles op zijn plek staat verschijnt er een vink.\n• Het huiswerk is niet meer blauw gekleurd.'
    },
    {   
        title: 'ZET JE TAKEN OP DE JUISTE VOLGORDE',
        subTitle: 'Bedenk of je een pauze inlast',
        bodyText: '• Kijk vooraf in de takenlijst of je een pauze wilt invoegen. Als dat zo is, maak dan met de plusknop rechtsboven een extra taak aan.\n• Schuif de taken in de juiste volgorde.\n• Begin met iets makkelijks, dan heb je alvast wat gedaan.\n• Kies als tweede iets moeilijks of belangrijks.\n• Wissel leer- en maakwerk met elkaar af..\n• Wissel talen met andere vakken af.\n• Door hierover na te denken bepaal je ook prioriteiten.\n• Bewaar dus ook het minst belangrijke tot het laatst.'
    },

    {   
        title: 'MAAK JE HUISWERK',
        subTitle: 'Zet de Plenda Tracker aan',
        bodyText: '• Bedenk of je met of zonder timer wilt werken.\n• Als je het heel druk hebt, kun je met timer je tijd onder controle houden.\n• Als je je wilt focussen helpt het om de timer te gebruiken.\n• Klik op play, de Plenda Tracker opent en als je ook hier op play drukt, begint ie te lopen.\n• Hij laat zien hoe lang je nog voor je taak ingepland hebt als je voor tijdsindicatie hebt gekozen.\n• Als je taak klaar is klik je op het vinkje en gaat de Tracker door naar de volgende taak.\n• Als je met de timer werkt en de tijd is voorbij, maar de taak nog niet klaar is, kun je kiezen of je 5 minuten wilt snoozen of stoppen.\n• Heb je weinig tijd, doe dan eerst een andere taak.\n• Ben je bijna klaar kies dan voor snoozen.\n• Ga door tot alles af is.\n• Achter alle taken die af zijn staat nu een vinkje.'
    },
    {   
        title: 'ALLES AFGEVINKT?',
        subTitle: 'Dan ben je klaar!',
        bodyText: '• Kijk of er achter elke taak een vinkje staat.\n• Het huiswerk waarvan alle taken zijn afgerond, is in het agenda-gedeelte grijs geworden. \n• Als je nog niet klaar bent en je hebt geen tijd meer, schuif je taak dan naar een volgende dag. Dit kan alleen als je je aanwent huiswerk te maken op de dag dat je het opkrijgt.'
    },
];

class Tips extends Component {

    constructor() {
        super();

        this.state = {
            showMenu: false
        };

        this.switchMenu = this.switchMenu.bind(this);
    }

    switchMenu(e) {
        this.state.showMenu ? this.setState({ showMenu: false }) : this.setState({ showMenu: true });
    }

    goToOnboarding() {
        history.push('/onboarding');
    }

    render() {
        return (
            <div styleName="profile-background">
                <div styleName='hamburger-icon' onClick={this.switchMenu}><FontAwesomeIcon styleName='icon' icon={[ 'far', 'bars' ]}/></div>
                <Popup handleClose={this.switchMenu} visible={this.state.showMenu} click={this.switchMenu}>
                    <Menu handleClose={this.switchMenu} open={this.state.showMenu} click={this.switchMenu}/>
                </Popup>
                <div styleName="content">
                    <div styleName="tip" style={{marginBottom: '0.75rem'}}>
                        <h1>Introductie</h1>
                        <DefaultButton textStyle={{alignItems:'center'}} handleClick={this.goToOnboarding} noarrow style={{width:'fit-content', borderRadius: '3px',}} title="Naar introductie" type="blue" />
                    </div>
                    <div styleName='tip'>
                        <h1 style={{ fontWeight: '800' }}>MAAK SLIM JE HUISWERK MET EEN GOED GEPLAND PLAN</h1>
                        <p>Focussen. Met huiswerk, activiteiten na school, internet en social media zit je hoofd en agenda al snel vol. Hoe zorg je er nou
                            voor dat je al dat huiswerk, zonder gestress, onder controle krijgt? Dat je geconcentreerd en effectief werkt en de baas wordt
                            over je eigen tijd? Dat kan door te plannen.</p>
                        <h2>Plenda App</h2>
                        <p>Onze applicatie werkt met de vertrouwde Plenda methode, waarbij huiswerk genoteerd, ingepland en afgevinkt
                            wordt. Hij heeft echter meer slimmigheidjes, zoals o.a. de Plenda Tracker, die je precies laat zien hoe ver je bent en helpt te
                            focussen. Met de uitleg in de App en het 6 Stappenplan kun je direct aan de slag.</p>
                        <p>Gebruik de app op je laptop, de iPad of je smartphone, hoe groter het scherm des te beter het overzicht.</p>
                        <div styleName='facts'>
                            <div styleName='fact-wrapper noBackground' >
                                <iframe width="100%" height="191px" src="https://www.youtube.com/embed/z-kC-LlsB4Q" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                            <div styleName='fact-wrapper noBackground' >
                                <iframe width="100%" height="191px" src="https://www.youtube.com/embed/-Rieb0fW0GM" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                        </div>
                        <img styleName='image' src="/images/tips/laptop.png"></img>
                    </div>
                    <div styleName='tip'>
                        <h1>6 STAPPEN PLAN</h1>
                    </div>
                    {
                        sixSteps.map((step, index) => 
                            <div key={index} styleName='tip-wrapper'>
                                <div styleName='titlebar'>
                                    <div styleName='number'>
                                        <h2>{(index + 1)}</h2>
                                    </div>
                                    <div styleName='text'>
                                        <h2 styleName='header'>{step.title}</h2>
                                        {step && step.subTitle && <p styleName='body-text'>{step.subTitle}</p>}
                                    </div>
                                </div>
                                <div styleName='tip-content'>
                                    {
                                        index == 5 &&
                                        <img styleName='check-image' src="/images/logos/check.svg"></img>
                                    }
                                    <p style={{ whiteSpace: 'pre-line' }}>{step.bodyText}</p>
                                </div>
                            </div>
                        )
                    }
                    <div styleName='tip'>
                        <h1>Feitjes & Weetjes</h1>
                    </div>
                    <div styleName='facts'>
                        <div styleName='fact-wrapper' >

                            <img styleName='small-image' src="/images/tips/8.png"></img>

                            <p styleName='fact-text'>Iets afvinken en daarmee een taak afronden, geeft voldoening. Je maakt dan endorfine aan, dat is een geluksstofje.</p>
                        </div>
                        <div styleName='fact-wrapper' >
                            <img styleName='small-image' src="/images/tips/9.png"></img>

                            <p styleName='fact-text'>Als je de timer gebruikt, wordt de verleiding om te vroeg te stoppen of te lang door te gaan, een stuk minder groot.</p>
                        </div>
                        <div styleName='fact-wrapper' >
                            <img styleName='small-image' src="/images/tips/10.png"></img>

                            <p styleName='fact-text'>Plan je huiswerk dezelfde dag als dat je het opkrijgt, dat voorkomt stress. Door te plannen ben je de baas over je eigen tijd.</p>
                        </div>
                        <div styleName='fact-wrapper' >
                            <img styleName='small-image' src="/images/tips/11.png"></img>

                            <p styleName='fact-text'>Wen jezelf aan dat je je maakwerk op dezelfde dag maakt als dat je het op krijgt. Als je het niet afkrijgt kun je het doorschuiven naar een andere dag.</p>
                        </div>
                        <div styleName='fact-wrapper' >
                            <img styleName='small-image' src="/images/tips/12.png"></img>

                            <p styleName='fact-text'>Als je een groot doel opdeelt in kleinere doelen, wordt het makkelijker haalbaar.</p>
                        </div>
                        <div styleName='fact-wrapper' >
                            <img styleName='small-image' src="/images/tips/13.png"></img>

                            <p styleName='fact-text'>Wat is lekkerder? In 1x twee liter cola opdrinken, of iedere dag een glas? Zo werkt het met leren ook. Beter in stukken opgedeeld, dan alles ineens.</p>
                        </div>
                        <div styleName='fact-wrapper' >
                            <img styleName='small-image' src="/images/tips/14.png"></img>

                            <p styleName='fact-text'>Weet je hoe jouw brein werkt? Door leerstof met aandacht te herhalen, verplaats je de stof van het korte naar het lange termijn geheugen (jouw harde schijf). Hierdoor sla je het beter op en kun je het op lange termijn weer terug halen. Als je de SO’s op deze manier leert, ben je met het proefwerk sneller klaar! Zo bespaar je uiteindelijk tijd en energie.</p>
                        </div>
                        <div styleName='fact-wrapper' >
                            <img styleName='small-image' src="/images/tips/16.png"></img>

                            <p styleName='fact-text'>Door prioriteiten te stellen in je takenlijst, richt je je aandacht op het juiste.</p>
                        </div>
                        <div styleName='fact-wrapper' >
                            <img styleName='small-image' src="/images/tips/17.png"></img>

                            <p styleName='fact-text'>Door te werken met een duidelijke en haalbare takenlijst, zul je zien dat het makkelijker is om aan de slag te gaan.</p>
                        </div>
                        <div styleName='fact-wrapper' >
                            <img styleName='small-image' src="/images/tips/18.png"></img>

                            <p styleName='fact-text'>Probeer om de 25 minuten even 5 minuten pauze te nemen. Na een uur kun je een langere pauze nemen.</p>
                        </div>
                        <div styleName='fact-wrapper' >
                            <img styleName='small-image' src="/images/tips/19.png"></img>

                            <p styleName='fact-text'>Word je afgeleid door een appje, door een game? Maak er een beloning van! Geniet er van in je pauze.</p>
                        </div>
                        <div styleName='fact-wrapper' >
                            <img styleName='small-image' src="/images/tips/20.png"></img>

                            <p styleName='fact-text'>Heb je wekelijks terugkerende activiteiten zoals je voetbaltraining of drumles, zet deze dan bij je lesrooster op het 9e uur. Je kunt hier dan rekening mee houden als je gaat plannen.</p>
                        </div>
                        <div styleName='fact-wrapper' >
                            <img styleName='small-image' src="/images/tips/4.png"></img>

                            <p styleName='fact-text'>Heb je een losse activiteit deze week? Een bioscoopbezoek, de verjaardag van oma of een voetbaltoernooi? Plan dit in het onderste gedeelte in de takenlijst als losse taak zodat je het niet vergeet en er je huiswerktaken omheen kunt plannen! Gebruik hiervoor de +button rechtsboven in het scherm.</p>
                        </div>
                    </div>
                    {/* {
                        tipsArray.map((tip, index) =>
                            <div key='index' styleName="tip">
                                {index == 0 && <h2>Tips</h2>}
                                <img styleName='image' src={`/images/tips/${tip.image}`}></img>
                                <p>{tip.text} </p>
                            </div>
                        )
                    } */}
                    {
                        /*
                    
                    <div styleName="tip">
                        <h2>Verkort noteren</h2>
                        <iframe styleName="video" src="https://www.youtube.com/embed/Bey4XXJAqS8" frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen></iframe>
                        <p>Gebruik afkortingen om overzicht te houden. Gebruik in plaats van “paragraaf” de afkorting “par”. Het is ook mogelijk een foto toe te voegen van het huiswerk op het bord of takenlijst. </p>
                    </div> */
                    }
                    
                </div>
            </div>
        );
    }
}

export default Tips;